// extracted by mini-css-extract-plugin
export default {"floatingBtn":"CreateAppointmentFloatingButton_floatingBtn__425mW"};